import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import { comissoesApi } from '../../api/rh';
import { COLORS } from '../../theme';
import { useTituloPagina } from '../../context/PageTitleContext';

const NOMES_MES = [
  '', 'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
  'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
];

function formatarReais(v) {
  return (Number(v) || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export default function ComissoesDetail({ funcionarioId, funcionarioNome, ano, mes, onVoltar }) {
  useTituloPagina(`Comissões — ${funcionarioNome}`);
  const [pedidos, setPedidos] = useState([]);

  useEffect(() => {
    const params = { funcionario_id: funcionarioId, ano };
    if (mes) params.mes = mes;
    comissoesApi.detalhe(params).then(setPedidos).catch(() => {});
  }, [funcionarioId, ano, mes]);

  const grupos = {};
  pedidos.forEach(p => { (grupos[p.mes] = grupos[p.mes] || []).push(p); });
  const mesesOrdenados = Object.keys(grupos).map(Number).sort((a, b) => b - a);

  const totalGeral = pedidos.reduce((s, p) => s + Number(p.valor_comissao), 0);

  return (
    <div>
      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12, marginBottom: 16, borderBottom: `1px solid ${COLORS.border}`, paddingBottom: 14 }}>
          <div>
            <strong style={{ fontSize: 15 }}>{funcionarioNome}</strong>
            <div style={{ fontSize: 12, color: COLORS.textMid, marginTop: 2 }}>
              Comissão em {ano}{mes ? ` — ${NOMES_MES[Number(mes)]}` : ''}: <strong style={{ color: COLORS.primary }}>{formatarReais(totalGeral)}</strong>
            </div>
          </div>
          <Btn variante="ghost" onClick={onVoltar}>Voltar</Btn>
        </div>

        {mesesOrdenados.map(m => {
          const linhas = grupos[m];
          const subtotal = linhas.reduce((s, p) => s + Number(p.valor_comissao), 0);
          return (
            <div key={m} style={{ marginBottom: 18 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: COLORS.textMid, textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 6 }}>
                {NOMES_MES[m]}
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
                <thead>
                  <tr style={{ textAlign: 'left', background: COLORS.bg }}>
                    <th style={{ padding: 8 }}>Nº Pedido</th>
                    <th style={{ padding: 8 }}>Data</th>
                    <th style={{ padding: 8 }}>Cliente</th>
                    <th style={{ padding: 8 }}>Valor do Pedido</th>
                    <th style={{ padding: 8 }}>Comissão</th>
                  </tr>
                </thead>
                <tbody>
                  {linhas.map(p => (
                    <tr key={p.pedido_id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                      <td style={{ padding: 8 }}>#{p.numero}</td>
                      <td style={{ padding: 8 }}>{new Date(p.criado_em).toLocaleDateString('pt-BR')}</td>
                      <td style={{ padding: 8 }}>{p.cliente_nome}</td>
                      <td style={{ padding: 8 }}>{formatarReais(p.valor_total_pedido)}</td>
                      <td style={{ padding: 8, fontWeight: 600, color: COLORS.primary }}>{formatarReais(p.valor_comissao)}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{ background: COLORS.primaryBg }}>
                    <td colSpan={4} style={{ padding: 8, textAlign: 'right', fontWeight: 700, color: COLORS.primary }}>Subtotal do mês</td>
                    <td style={{ padding: 8, fontWeight: 700, color: COLORS.primary }}>{formatarReais(subtotal)}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          );
        })}

        {pedidos.length === 0 && (
          <p style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhuma venda com comissão nesse período.</p>
        )}
      </Card>
    </div>
  );
}
